import Vue from 'vue';
import VueModal from 'vue-js-modal';
import { i18n, loadDefaultLanguage } from '@v4/locale/async';
import HeroSearchForm from '@v4/home-page/components/organisms/HeroSearchForm.vue';
import Header from '@v4/header';
import { LIST_HOME_PAGE } from '@v4/common/utils/data-layer';
import dataLayerHandler from '@v4/common/components/mixins/data-layer-handler';
import { dkModalAware } from '@v4/common/components/mixins/modal';
import gaEventHandler from '@v4/common/components/mixins/google-analytics';
import '@v4/common/utils/lazy-load';

(async () => {
    await loadDefaultLanguage();

    if (document.getElementById('home-page')) {
        Vue.use(VueModal, { dynamic: true, injectModalsContainer: true });

        new Vue({
            el: '#home-page',
            name: 'HomePage',
            i18n,
            components: {
                HeroSearchForm,
                DkSlide: () => ({
                    component: import(
                        /* webpackChunkName: "DkSlide-vue" */ '@v4/common/components/atoms/DkSlide/DkSlide.vue'
                    ),
                }),
                DkBadge: () => ({
                    component: import(
                        /* webpackChunkName: "DkBadgeDST-vue" */ '@v4/common/components/atoms/DkBadgeDST.vue'
                    ),
                }),
                DkSlider: () => ({
                    component: import(
                        /* webpackChunkName: "DkSlider-vue" */ '@v4/common/components/molecules/DkSliderDST.vue'
                    ),
                }),
                PromoBanner: () => ({
                    component: import(
                        /* webpackChunkName: "PromoBanner-vue" */ '@v4/common/components/molecules/PromoBanner/PromoBanner.vue'
                    ),
                }),
                MakeLogo: () => ({
                    component: import(
                        /* webpackChunkName: "MakeLogo-vue" */ '@v4/common/components/atoms/MakeLogo.vue'
                    ),
                }),
                DkButton: () => ({
                    component: import(
                        /* webpackChunkName: "DkButton-vue" */ '@v4/common/components/atoms/DkButton.vue'
                    ),
                }),
                DkNewsCard: () => ({
                    component: import(
                        /* webpackChunkName: "DkNewsCard-vue" */ '@v4/common/components/organisms/DkNewsCard.vue'
                    ),
                }),
            },
            mixins: [dkModalAware, dataLayerHandler, gaEventHandler],
            data() {
                return {
                    newsSliderOptions: {
                        slidesPerView: 4,
                        spaceBetween: 15,
                        pagination: false,
                        breakpoints: {
                            767: {
                                slidesPerView: 'auto',
                            },
                        },
                    },
                    showAllMakes: false,
                };
            },
            methods: {
                onPromoCardClick(vehicle) {
                    this.pushProductClickToDataLayer(vehicle, { list: LIST_HOME_PAGE });
                },
                onPromoBannerBtnClick() {
                    this.pushGaEvent('EV page', 'EV link click', 'Click on banner CTA');
                },
                onPromoBannerClick() {
                    this.pushGaEvent('EV page', 'EV link click', 'Click on banner image');
                },
                onPromoBannerDisclaimerIconClick(disclaimer) {
                    return import(
                        /* webpackChunkName: "DisclaimerModal-vue" */ '@v4/common/components/atoms/DisclaimerModal'
                    ).then(
                        async ({ default: DisclaimerModal }) =>
                            await this.showModal(
                                DisclaimerModal,
                                {
                                    disclaimer,
                                },
                                {
                                    name: 'disclaimer-modal',
                                    height: 'auto',
                                    classes: 'modal--fullscreen_medium',
                                    width: 515,
                                    scrollable: true,
                                },
                                {},
                                {
                                    disableBodyScroll: false,
                                }
                            )
                    );
                },
                onGuideClick(id, title, category) {
                    const kbs = window.kbs;

                    const dataKbs = {
                        pageCategory: 'hp',
                        source: window.location.href,
                        articleCategory: category,
                        titleGuide: title,
                    };

                    kbs.track('clickFormulaPassion', dataKbs);

                    this.pushGaEvent('select_content', null, null, {
                        // eslint-disable-next-line camelcase
                        content_type: category,
                        // eslint-disable-next-line camelcase
                        item_id: id,
                        // eslint-disable-next-line camelcase
                        title_guide: title,
                        // eslint-disable-next-line camelcase
                        page_source: window.location.href,
                    });
                },
                toggleShowAllMakes() {
                    this.showAllMakes = !this.showAllMakes;
                },
            },
        });
    }

    if (document.getElementById('header')) {
        Header();
    }
})();
